<template>
  <div class="page-index">
    <GoodsListNav></GoodsListNav>
    <HomeNav></HomeNav>
    <div class="main-container">
      <div class="container">
        <!-- 推荐列表 -->
        <div class="item-class" v-for="(value, i) in homeList" :key="i">
          <div v-for="(list, key) in homeList[i]" :key="key">
            <div class="item-class-head">
              <span class="item-class-title">
                <span class="text-active">{{i+1 + 'F'}}</span> 
                <span class="line"></span>
                {{key.split('_')[1]}}
              </span>
              <span class="item-class-right text-active">
                <router-link :to="'/list/'+key.split('_')[0]">
                  查看更多
                  <Icon type="ios-arrow-dropright-circle" />
                </router-link>
              </span>
            </div>
            <div class="item-class-content">
              <div class="item-content-img" v-for="(item, index) in list" :key="index">
                <router-link :to="'/detail/'+item.id">
                  <img :src="item.productUrl">
                </router-link>
                <div class="name">{{item.productName}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GoodsListNav from '@/components/nav/GoodsListNav';
import HomeNav from '@/components/nav/HomeNav';
import { mapState, mapActions } from 'vuex';
export default {
  name: 'Index',
  created () {
    this.loadBannerList({
      current: 1,
      size: 6,
      bannerType: 1
    });
    this.loadHomeList();
  },
  data () {
    return {
      partnersList: []
    };
  },
  methods: {
    ...mapActions(['loadBannerList', 'loadHomeList']),
  },
  computed: {
    ...mapState(['bannerList', 'homeList']),
  },
  components: {
    GoodsListNav,
    HomeNav
  },
};
</script>

<style lang="less" scoped>
.container {
  margin: 0px auto;
  width: @page-main-width;
  min-height: @main-min-height;
  background-color: #FFFFFF;
  padding-bottom: 30px;
}

/*****************************商品专栏开始*****************************/
.item-class {
  width: 100%;
  padding-top: 15px;
  padding-bottom: 30px;
  background-color: #fff;
  background-color: #fff;
  overflow: hidden;
}
.item-class-head {
  width: 100%;
  height: 28px;
  line-height: 28px;
  font-size: 20px;
  overflow: hidden;
  display: flex;
  justify-content: space-between;
}
.item-class-title {
  margin-left: 15px;
  font-weight: 500;
  color: #000;

  span.line {
    display: inline-block;
    width: 2px;
    height: 15px;
    background-color: @theme-code;
    transform: rotate(45deg);
    position: relative;
    left: -10px;
    top: 2px;
  }
}
.item-class-right {
  cursor: pointer;
  font-size: 14px;
  margin-right: 18px;
  /deep/.ivu-icon {
    font-size: 17px;
    color: @theme-code;
  }
  a {
    color: @theme-code;
  }
}
.item-class-content {
  width: 100%;
  cursor: pointer;
  float: left;
  margin-top: 10px;
}


.item-content-img {
  cursor: pointer;
  margin-right: 16px;
  overflow: hidden;
  float: left;
  background: #F8F8F8;
  font-size: 0;
}
.item-content-img img {
  width: 224px;
  height: 222px;
}

.item-content-img .name {
  width:224px;
  height: 40px;
  line-height: 40px;
  font-size: 12px;
  padding: 0 15px 0 20px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
/*****************************商品专栏结束*****************************/
</style>



// WEBPACK FOOTER //
// src/views/Index.vue